module.exports = __webpack_public_path__ + "static/media/iPhone14-4.38a5ce86.png";